<template>
  <div
    class="d-flex flex-column align-content-between mobile-container"
    :class="{ 'companies-step-active': currentStep === 'companies' }"
  >
    <div
      v-if="currentStep !== 'confirmation'"
      class="nav navbar py-4 font-24 fw-bold d-flex justify-content-center"
      :class="{ 'bg-custom': currentStep === 'companies' }"
    >
      <h2 v-if="currentStep === 'password'" class="logo-container">
        <img src="../assets/images/bloom_logo.svg" class="logo-image"/>
      </h2>
      <div
        class="w-50 text-left header"
        v-if="currentStep === 'companies'"
        style="text-align:center!important"
      >
        <span class="text-white title">Bloomキャリア登録 導入企業一覧</span>
      </div>
    </div>

    <!-- Password Setup Component -->
    <PasswordSetup
      v-if="currentStep === 'password'"
      :token="token"
      :userId="user_id"
      :buttonStyle="styleButton"
      @password-submitted="handlePasswordSubmitted"
      @redirect="handleRedirect"
    />

    <!-- Confirmation Page Component -->
    <ConfirmationPage
      v-if="currentStep === 'confirmation'"
      :buttonStyle="styleButton"
      @ok-clicked="handleConfirmationOk"
    />

    <!-- Welcome Message -->
    <div
      class="d-flex justify-content-center body-content"
      v-if="currentStep === 'welcome'"
    >
      <div class="w-50 d-flex align-items-center flex-column">
        <div class="mt-5 mb-5">
          <img
            src="../assets/images/confirm.svg"
            alt="thankyou image"
            class="img-fluid"
          />
        </div>
        <div class="d-flex flex-column">
          <p
            class="font-18 mb-4 fw-bold w-100"
            style="text-align:center"
          >
            「Bloomキャリア登録」を利用する大手企業各社へ登録が可能です<br />
            登録可能企業を次の画面でご確認ください
          </p>
        </div>
        <button
          class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
          @click="showCompaniesList"
          :style="styleButton"
        >
          次へ（登録可能企業を表示）
        </button>
      </div>
    </div>

    <!-- Companies List Component -->
    <CompaniesList
      v-if="currentStep === 'companies'"
      class="companies-step-panel"
      :companies="companies"
      :companyData="companyData"
      :token="token"
      :userId="user_id"
      @redirect="handleRedirect"
      @registration-complete="clearVerifyState"
    />
  </div>
</template>

<script>
import PasswordSetup from './PasswordSetup.vue';
import ConfirmationPage from './ConfirmationPage.vue';
import CompaniesList from './CompaniesList.vue';

export default {
  name: 'VerifyEmail',
  components: {
    PasswordSetup,
    ConfirmationPage,
    CompaniesList
  },
  data() {
    return {
      token: this.$route.params.token,
      user_id: this.$route.params.id,
      companies: [],
      companyData: undefined,
      currentStep: 'password', // 'password', 'confirmation', 'welcome', 'companies'
    };
  },
  computed: {
    styleButton() {
      return {
        background: 'red',
        'border-color': 'red',
      };
    },
  },
  methods: {
    getVerifyStateKey() {
      return `verify-email-flow:${this.user_id}`;
    },
    persistVerifyState() {
      sessionStorage.setItem(
        this.getVerifyStateKey(),
        JSON.stringify({
          currentStep: this.currentStep,
          companies: this.companies,
          companyData: this.companyData,
          token: this.token,
        }),
      );
    },
    clearVerifyState() {
      sessionStorage.removeItem(this.getVerifyStateKey());
    },
    restoreVerifyState() {
      if (!this.$auth.isAuthenticated()) {
        return false;
      }

      const saved = sessionStorage.getItem(this.getVerifyStateKey());
      if (!saved) {
        return false;
      }

      try {
        const state = JSON.parse(saved);
        if (state.token && state.token !== this.token) {
          return false;
        }

        this.companies = state.companies || [];
        this.companyData = state.companyData;

        if (state.currentStep === 'companies' && this.companies.length > 0) {
          this.currentStep = 'companies';
          return true;
        }

        if (state.currentStep === 'confirmation' && this.companies.length > 0) {
          this.currentStep = 'confirmation';
          return true;
        }
      } catch (error) {
        this.clearVerifyState();
      }

      return false;
    },
    handlePasswordSubmitted(result) {
      const data = result.data && result.data.data ? result.data.data : result.data;
      const hasAuth = data && (data.expires_in !== undefined || data.access_token);
      if (hasAuth) {
        this.$auth.setToken(data);
      }
      if (result.data && result.data.companies) {
        // Companies are available, show confirmation then companies
        this.companies = result.data.companies;
        this.companyData = result.data.company;
        this.currentStep = 'confirmation';
        this.persistVerifyState();
      } else {
        // No companies, redirect to main page
        this.clearVerifyState();
        this.$router.push('/');
      }
    },
    handleConfirmationOk() {
      if (this.companies.length > 0) {
        this.currentStep = 'companies';
        this.persistVerifyState();
      } else {
        // Redirect to dashboard if no companies
        this.clearVerifyState();
        this.$router.push({ name: 'dashboard' });
      }
    },
    showCompaniesList() {
      this.currentStep = 'companies';
      this.persistVerifyState();
    },
    handleRedirect(route) {
      this.$router.push({ name: route });
    },
    async verify() {
      try {
        if (!this.token || !this.user_id) {
          this.$router.push({ name: 'pageNotFound' });
          return;
        }

        if (this.restoreVerifyState()) {
          return;
        }

        // Show password field immediately for verification
        this.currentStep = 'password';
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.$router.push({ name: 'login' });
        }
      }
    },
  },
  created() {
    this.verify();
  },
  metaInfo() {
    let title;
    if (this.currentStep === 'confirmation') {
      title = '認証完了';
    } else if (this.currentStep === 'password') {
      title = 'パスワード設定';
    } else if (this.currentStep === 'welcome') {
      title = '登録完了';
    } else {
      title = 'Bloomキャリア登録導入企業一覧 導入企業一覧';
    }
    return {
      title: `${title} | Bloomキャリア登録`,
    };
  },
};
</script>

<style scoped>
.mobile-container {
  overflow: auto;
}

.mobile-container.companies-step-active {
  overflow: hidden;
  height: 100vh;
  height: 100dvh;
}

.mobile-container.companies-step-active .companies-step-panel {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.mobile-container.companies-step-active > .nav {
  flex: 0 0 auto;
}

.bg-custom {
  background-color: #076d6c;
}

.navbar-white {
  background-color: #ffffff !important;
  border-bottom: 1px solid #e0e0e0;
}

.font-24 {
  font-size: 24px;
}

.font-18 {
  font-size: 18px;
}

.logo-container {
  margin: 0;
  padding: 0;
}

.logo-image {
  width: 400px;
  height: auto;
  max-width: 100%;
}

.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 8px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
}

@media only screen and (max-width: 992px) {
  .navbar > div,
  .body-content > div {
    width: 75% !important;
  }
  
  .logo-image {
    width: 300px;
  }
}

@media only screen and (max-width: 576px) {
  .navbar {
    justify-content: flex-start !important;
    padding: 0.5rem 1rem !important;
    margin-bottom: 1rem !important;
    min-height: auto;
  }
  
  .navbar > div,
  .body-content > div {
    width: 100% !important;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .logo-image {
    width: 200px;
    max-height: 36px;
    object-fit: contain;
  }
}

@media (max-width: 550px) {
  /* .mobile-container {
    height: 99vh !important;
  } */
  .text-white {
    font-size: 20px;
  }
  
  .navbar {
    padding: 0.5rem 1rem !important;
    margin-bottom: 1rem !important;
  }
  
  .logo-image {
    width: 200px;
    max-height: 36px;
    object-fit: contain;
  }
}
</style>
